<script setup>
import { ref } from 'vue';
import SettingsModal from './SettingsModal.vue';

const props = defineProps({
  user: Object,
  isAuthenticated: Boolean
});

const emit = defineEmits(['show-movie-list', 'login', 'logout', 'user-updated']);

const userMenuOpen = ref(false);
const settingsModalOpen = ref(false);

function handleShowMovieList() {
  window.location.hash = '';
}

function toggleUserMenu() {
  userMenuOpen.value = !userMenuOpen.value;
}

function closeUserMenu() {
  userMenuOpen.value = false;
}

function handleLogin() {
  emit('login');
}

function handleLogout() {
  emit('logout');
  closeUserMenu();
}

function handleSettings() {
  settingsModalOpen.value = true;
  closeUserMenu();
}

function handleCloseSettings() {
  settingsModalOpen.value = false;
}

function handleUserUpdated(updatedUser) {
  emit('user-updated', updatedUser);
}
</script>

<template>
  <header class="header">
    <div class="header-content">
      <button @click="handleShowMovieList">🎬</button>

      <div v-if="isAuthenticated" class="user" @click="toggleUserMenu" tabindex="0">
        <div class="user-avatar">
          <img v-if="user?.picture" :src="user.picture" :alt="user.name" />
          <span v-else>{{ user?.name?.charAt(0) || '👤' }}</span>
        </div>
        <div v-if="userMenuOpen" class="user-menu" @click.stop>
          <div class="user-info">
            <strong>{{ user?.name }}</strong>
            <small>{{ user?.email }}</small>
          </div>
          <ul>
            <li>
              <a href="#" @click.prevent
                >Top up<small>{{ user?.credits || 0 }} Credits</small></a
              >
            </li>
            <li><a href="#" @click.prevent="handleSettings">Settings</a></li>
            <li><a href="#" @click.prevent="handleLogout">Logout</a></li>
          </ul>
        </div>
      </div>
    </div>

    <SettingsModal :user="user" :is-open="settingsModalOpen" @close="handleCloseSettings" @user-updated="handleUserUpdated" />
  </header>
</template>

<style scoped>
.user {
  position: relative;
  .user-avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #007bff;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    cursor: pointer;
    overflow: hidden;
  }

  .user-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .user-menu {
    position: absolute;
    top: 100%;
    right: 0;
    background: var(--color-sidebar-bg);
    border: 1px solid var(--color-border);
    border-radius: var(--border-radius);
    color: var(--color-text);
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    min-width: 200px;
    z-index: 1000;
    margin-top: var(--padding-header);

    .user-info {
      padding: var(--padding-header);
      border-bottom: 1px solid var(--color-border);
    }

    strong {
      display: block;
      margin-bottom: var(--padding-header);
    }

    small {
      display: block;
      opacity: 0.8;
    }

    ul {
      list-style: none;
      margin: 0;
      padding: 0;
    }
    li a {
      display: block;
      padding: var(--padding-header);
      color: var(--color-text);
      text-decoration: none;
      transition: background var(--transition);
      &:hover {
        background: var(--color-sidebar-header-bg);
      }
    }
  }
}
</style>
